export function formatEntityReference(
	entityType: string,
	entityReference: string | number | null,
): string {
	if (entityReference === null) return "-";

	switch (entityType) {
		case "PROPOSITION":
			return String(entityReference);
		case "CONSTRUCTION_SITE":
			return `CH-${Number(entityReference).toString().padStart(5, "0")}`;
		case "BROKER":
			return String(entityReference);
		case "GFA":
			return `CH-${Number(entityReference).toString().padStart(5, "0")}`;
		default:
			return "-"
	}
}

